// extracted by mini-css-extract-plugin
module.exports = {"educationMainDiv":"Education_educationMainDiv__2s85A","educationDiv":"Education_educationDiv__3OpiP","carouselCard":"Education_carouselCard__Lt36Y"};